import React from 'react';

export default function ({ highlightsfeed, eleRef }) {
    return (


<section className="main_container_block_feeds">
                                <div className="main_block_container_feed">
                                   <div className="block_container_feed_heading_text R15_61">
                                      {highlightsfeed.title?highlightsfeed.title:''}{/*<span className="dny-b-15"> Discussion </span> you might be interested in*/}
                                    </div>
                                     
                                    <div className="content-div-box-artical spacial_Milestone_desktop">
                                    <div className="view_discussion_profile_Pros">
                                        <div className="view_discussion_name_new_profile"> 
                                            {highlightsfeed.data[0].userPhoto!="" ?
                                            <img src={highlightsfeed.data[0].userPhoto?highlightsfeed.data[0].userPhoto:''} />:
                                            <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Live Sessions dummy img.webp" alt="logo"/> 
                                            }
                                        </div>
                                        <div className="discussion_profile_Pros"> 
                                             <div className="M15_21">{highlightsfeed.data[0].userName?highlightsfeed.data[0].userName:''}</div>
                                             <div className="post_delevery R14_9e">{highlightsfeed.data[0].userDesc}</div>
                                        </div>
                                    </div>
                                    <div className="content-div_view_artical">freehight_banner
                                        <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/freehight_banner.webp" alt="logo"/>
                                    </div>
                                    <div className="the_week_game_vido"> 
                                        <div className="fabulous_text">{highlightsfeed.data[0].title?highlightsfeed.data[0].title:''}</div>
                                        <div className="week_card-text more"> 
                                             <span className="R15_61 my_baby_question_ask"> 
                                               {highlightsfeed.data[0].discription?highlightsfeed.data[0].discription:''}
                                              </span>
                                             <a href={highlightsfeed.data?highlightsfeed.data[0].redirectionUrl:''} className="readmorelink R14_link"> Read more</a>
                                        </div>
                                    </div>
                                    
                                    <div className="profile_comments_view">
                
                                    <div className="bottom_line_divider_feed"> </div>
                                     <div className="baby-week-social-view meal_planner_healthy_social"> 
                                        <div className="post-options">
                                          <div className="icon left comment_icons_1" data-icon-font="e"> <span className="icons-text R13_61">{highlightsfeed.data[0].commentCount?highlightsfeed.data[0].commentCount:''}</span> </div>
                                          <div className="icon left devMemoLike font-sizeview" data-icon-font="$"> <span className="icons-text R13_61">{highlightsfeed.data[0].likeCount?highlightsfeed.data[0].likeCount:''}</span> </div>
                                          <div className="icon left devMemoLike comment_icons_1_font-size" data-icon-font="?"> <span className="icons-text R13_61"> {highlightsfeed.data[0].participantCount?highlightsfeed.data[0].participantCount:''} Participants</span> </div>
                                          
                                          <div className="icon left dotted_icons" > </div>
                                        </div>
                                    </div>
                                    <div className="fc_border_bottom_1"> </div>
                                     <div className="baby-week-social-view meal_planner_healthy_social social_me_test_without_text mr_b4"> 
                                        <div className="post-options">
                                          <div className="icon left" data-icon-font="e"> <span className="icons-text R13_61"> Comment </span> </div>
                                          <div className="icon left devMemoLike follow_icons_1_font-size"> <span className="icons-text R13_61"> Follow </span> </div>
                                          
                                          <div className="icon left m-abuse-main right"> 
                                            <div className="icon left icon3dot facebookicons" data-icon-font="J"></div>
                                            <div className="icon left icon3dot whatsapp-icons" data-icon-font=""> <span className="icons-text icons-text_top_meal R13_61 cursor-pointer gtm-share"> Share </span></div>
                                          </div>
                                         
                                        </div>
                                    </div>
                                    
                                    </div>
                                 </div>
                                </div>
                            </section>
    )
                                        }
